export function jobnetList() {
    const roots = document.querySelectorAll(".jobnet-list");

    roots.forEach((root) => {
        const rootCards = root.querySelectorAll(".card[data-tag]");
        const select = root.querySelector(".jobnet-list-select, .emplySelect");
        const cards =
            rootCards.length > 0
                ? rootCards
                : root.querySelectorAll(".card[data-tag]");

        if (!select || !cards.length) {
            return;
        }

        const searchForm =
            root.querySelector(".jobnet-list-search, #jobnet-search");
        const searchInput = searchForm?.querySelector("input");

        const resultText =
            root.querySelector(".jobnet-list-result-text, #resultText");

        const updateResultText = (visibleCount) => {
            if (!resultText) {
                return;
            }

            const template = resultText.getAttribute("data-resulttext") || "";
            const text = template.replace("#", visibleCount.toString());

            const paragraph = resultText.querySelector("p");
            if (paragraph) {
                paragraph.textContent = text;
            } else {
                resultText.textContent = text;
            }
        };

        const applyFilter = () => {
            const selectedTag = select.value.toLowerCase();

            let visibleCount = 0;

            cards.forEach((card) => {
                const tag = (card.getAttribute("data-tag") || "").toLowerCase();
                let isVisible = selectedTag === "all" || tag === selectedTag;

                if (searchInput) {
                    const title = (card.getAttribute("data-title") || "").toLowerCase();
                    const searchText = searchInput.value.trim().toLowerCase();
                    const matchesTitle = !searchText || title.includes(searchText);
                    isVisible = isVisible && matchesTitle;
                }

                card.style.display = isVisible ? "" : "none";

                if (isVisible) {
                    visibleCount++;
                }
            });

            updateResultText(visibleCount);
        };

        const applyLoadMoreFilter = () => {
            const loadMoreButton = root.querySelector(".js-jobnet-load-more");
            const cardsContainer = root.querySelector(".list__cards");

            if (!loadMoreButton || !cardsContainer) {
                return;
            }

            loadMoreButton.addEventListener("click", async function () {
                const url = loadMoreButton.dataset.loadMoreUrl;

                if (!url) {
                    return;
                }

                loadMoreButton.disabled = true;

                try {
                    const response = await fetch(url, {
                        headers: {
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    });

                    if (!response.ok) {
                        throw new Error("Failed to load more jobs.");
                    }

                    const html = await response.text();
                    const temp = document.createElement("div");
                    temp.innerHTML = html;

                    const newCardsContainer = temp.querySelector(".list__cards");
                    if (!newCardsContainer) {
                        loadMoreButton.disabled = false;
                        return;
                    }

                    const newCards = Array.from(newCardsContainer.children);
                    newCards.forEach((card) => {
                        cardsContainer.appendChild(card);
                    });

                    applyFilter();

                    const totalCount = parseInt(loadMoreButton.dataset.totalCount || "0", 10);
                    const loadedCount = root.querySelectorAll(".card[data-tag]").length;

                    if (loadedCount >= totalCount || newCards.length === 0) {
                        loadMoreButton.closest(".pagination")?.remove();
                        return;
                    }

                    const currentUrl = new URL(url, window.location.origin);
                    const currentPage = parseInt(currentUrl.searchParams.get("page") || "1", 10);
                    currentUrl.searchParams.set("page", String(currentPage + 1));
                    loadMoreButton.dataset.loadMoreUrl = currentUrl.pathname + currentUrl.search;
                } catch {
                    loadMoreButton.disabled = false;
                }
            });
        };

        select.addEventListener("change", applyFilter);

        if (searchForm && searchInput) {
            searchForm.addEventListener("submit", function (e) {
                e.preventDefault();
                applyFilter();
            });
            searchInput.addEventListener("input", applyFilter);
        }

        applyFilter();
        applyLoadMoreFilter();
    });
}

export default jobnetList;
